import { render } from "./FluidsTestTab.vue?vue&type=template&id=14da4f40&scoped=true"
import script from "./FluidsTestTab.vue?vue&type=script&lang=js"
export * from "./FluidsTestTab.vue?vue&type=script&lang=js"

import "./FluidsTestTab.vue?vue&type=style&index=0&id=14da4f40&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14da4f40"]])

export default __exports__